// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"e9c2de8d","631":"216fb14c","760":"f5780ade","774":"a12c292c","787":"42b19fee","854":"27ebd232"}[chunkId] + ".chunk.js";
};